module.exports = __webpack_public_path__ + "img/full7-min.9686c6a3.png";